import { useEffect, useRef } from "react";
import { trackAdsConsultationConversion } from "../utils/analytics";

const CalendlyEmbed = ({ 
  url = "https://calendly.com/rnb-consulting-group/free-discovery-call",
  minWidth = "320px",
  height = "700px",
  className = ""
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Ensure the Calendly widget script is loaded and initialize
    if (window.Calendly && containerRef.current) {
      window.Calendly.initInlineWidget({
        url: url,
        parentElement: containerRef.current,
      });
    }

    // Listen for Calendly scheduling events
    const handleMessage = (e) => {
      if (e.data && e.data.event === 'calendly.event_scheduled') {
        trackAdsConsultationConversion();
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [url]);

  return (
    <div 
      ref={containerRef}
      className={`calendly-inline-widget ${className}`}
      data-url={url}
      style={{ minWidth, height }}
      data-testid="calendly-embed"
    />
  );
};

export default CalendlyEmbed;
